import type { FunctionComponent } from 'preact';

import { useTranslation } from '../../../../i18n';
import { encodeBase64 } from '../../../../utils/base-64.utils';
import { windowNavigate } from '../../../../utils/window.utils';
import type { Video } from '../../../models/video.interface';
import type { VideoBarRequest } from '../../../models/video-bar.interface';
import { VideoBarItem } from '../video-bar-item/video-bar-item.component';

export interface Props {
  request: VideoBarRequest;
  videoBar: Video[];
  showViewAll: boolean;
  showBadge: boolean;
  showVideoTitle: boolean;
  showVideoDate: boolean;
  showVideoArtist: boolean;
  showCardDropShadow: boolean;
  badgeText: string;
}

export const VideoBarGrid: FunctionComponent<Props> = ({
  request,
  videoBar,
  showViewAll,
  showBadge,
  showVideoTitle,
  showVideoDate,
  showVideoArtist,
  showCardDropShadow,
  badgeText,
}) => {
  const { t } = useTranslation();

  const viewVideoLanding = ($event: any): void => {
    $event.preventDefault();
    $event.stopPropagation();

    const req = encodeBase64(request);
    windowNavigate(`${window.location.origin}/apps/single/video-landing?encoded-request=${req}`);
  };

  return (
    <div>
      <div class="single-grid single-video-grid">
        <section class="single-grid-item">
          {videoBar &&
            videoBar.length > 0 &&
            videoBar.map((video) => (
              <VideoBarItem
                key={video.id}
                video={video}
                showTitle={showVideoTitle}
                showDate={showVideoDate}
                showArtist={showVideoArtist}
                showBadge={showBadge}
                showCardDropShadow={showCardDropShadow}
                badgeText={badgeText}
              />
            ))}
        </section>
      </div>
      {showViewAll && (
        <div class="single-view-all">
          <button class="button btn" onClick={viewVideoLanding}>
            {t('perks.viewAll')}
          </button>
        </div>
      )}
    </div>
  );
};
